"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportGeneratorColumn_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ReportGeneratorColumn_Factory = /** @class */ (function () {
    function ReportGeneratorColumn_Factory() {
    }
    ReportGeneratorColumn_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Id: model.Id,
            Name: model.Name,
        };
        return result;
    };
    ReportGeneratorColumn_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Id: model.Id,
            Name: model.Name,
        };
        return result;
    };
    return ReportGeneratorColumn_Factory;
}());
exports.ReportGeneratorColumn_Factory = ReportGeneratorColumn_Factory;
